import { type SelectItem } from "@mantine/core";

import { type ICheckListItem } from "./CheckLists.types";
import { IGroupedLog, ILog } from "src/interfaces/ChecklistLogbooks";

export const mapCheckListLogbooks = (data: any) => {
  const logbooks: SelectItem[] = [{ label: "All Logbooks", value: "*" }];
  if (data?.logbooks) {
    for (const log of data.logbooks) {
      if (log.parts) {
        logbooks.push({
          label: log.lbname,
          value: log.lbid,
          group: log.lbname,
        });
        logbooks.push(
          ...log.parts.map((l: any) => ({
            label: l.lbname,
            value: l.lbid,
            group: log.lbname,
          })),
        );
      } else {
        logbooks.push({ label: log.lbname, value: log.lbid });
      }
    }
  }
  return logbooks;
};

export const groupLogbooks = (logs: ILog[]) => {
  const parsed: IGroupedLog[] = [];
  logs &&
    logs.forEach(log => {
      if (!log.group) {
        parsed.push({ ...log, subSections: [] });
      } else {
        const matchingGroupIndex = parsed.findIndex(
          el => el.label === log.group,
        );
        if (matchingGroupIndex !== -1) {
          parsed[matchingGroupIndex].subSections.push(log);
        } else {
          parsed.push({ label: log.group, value: "", subSections: [] });
        }
      }
    });
  return parsed;
};

export const parseChecklists = (checklists: ICheckListItem[]) =>
  checklists
    .map((c, i) => ({
      ...c,
      symbol: `checklist-${i}`,
      sort: c.sort == null ? i + 1 : c.sort,
    }))
    .sort((a, b) => a.sort - b.sort);
